<div class="container">
  <ion-input
    [fill]="ionItemFill"
    [helperText]="searchHelperText"
    type="text"
    [label]="searchLabel"
    [labelPlacement]="ionLabelPosition"
    [ngModel]="searchValue"
    (ngModelChange)="searchValueChange($event)"
    [placeholder]="placeholder"
    debounce="300"
    (keydown.ArrowDown)="ionItemArrowDown($event)"
    (keydown.ArrowUp)="ionItemArrowUp($event)"
    (ionBlur)="onBlur($event)"
    [disabled]="disabled"
  />
  <ion-spinner *ngIf="loading"></ion-spinner>
</div>

<ion-card #container [hidden]="hideAutoCompleteItems$ | async" class="ion-no-margin">
  <cdk-virtual-scroll-viewport [itemSize]="70" [minBufferPx]="400" [maxBufferPx]="600"
    [style.height.px]="viewportHeight$ | async">

    <ion-item
      *cdkVirtualFor="let item of visibleItems$ | async; let index = index" lines="none"
      [button]="true"
      (pointerdown)="selectItemFromPointer($event, item)"
      [class.ion-focused]="index === activeSearchItemIndex"
      class="search-item"
      tabindex="-1"
      [attr.title]="item.subtitle || item.title"
    >
      <ion-label>
        <header class="title">
          <ion-row class="ion-justify-content-between ion-align-items-center">
            <span *ngIf="!item.fuseJsHighlighted">
              {{ item.title }}
            </span>
            <span *ngIf="item.fuseJsHighlighted" class="fusejs-highlight" [innerHTML]="item.fuseJsHighlighted.title"></span>

            <ion-badge *ngIf="item.badge" [color]="item.badge.color">
              {{ item.badge.text }}
            </ion-badge>
          </ion-row>
        </header>
        <small *ngIf="item.subtitle">{{ item.subtitle }}</small>
      </ion-label>
    </ion-item>

  </cdk-virtual-scroll-viewport>
</ion-card>
